<template>
    <el-dialog :visible.sync="showDetail" id="typeshowhtml" custom-class='xiangqing'  v-dialogDrag>
            <el-form>
             <div class="contrascont">
                <div class="hst">{{currentDetailInfo.projectLampparamVo.lampparamNo}} {{currentDetailInfo.projectLampparamVo.lampTypeStr}}</div>
                <div class="lsde">
                    <div class="toppom">
                        <!-- <div v-if="currentDetailInfo.projectLampparamVo.makingWay == 2"> -->
                        <div v-html="embedHhtml">
                            <!-- <embed :src="this.ImgPath + currentDetailInfo.projectLampparamVo.pdfPath" width="100%" height="725px"> -->
                        </div>
                        
                        <div class="lsdeList" v-if="showDetailFlag">
                            <ul>
                                <template v-if="isgdorPending==0 && userhaveRole">
                                <li @click="showAddToMyProject(2)"><img src="@/assets/images/bb1.jpg" alt="">添加至我的项目</li>  

                                <li v-if="currentDetailInfo.projectLampparamVo.dataStatus != 4 && currentDetailInfo.projectLampparamVo.makingWay==2" @click="showPDFEditView(currentDetailInfo.projectLampparamVo.id)"><img src="@/assets/images/bb3.jpg" alt="">修改</li>  
                                <li v-else-if="currentDetailInfo.projectLampparamVo.dataStatus != 4 && currentDetailInfo.projectLampparamVo.makingWay==1" @click="gotoUpdatePdf(currentDetailInfo.projectLampparamVo.id)"><img src="@/assets/images/bb3.jpg" alt="">修改</li>   
                                <li v-show="currentDetailInfo.projectLampparamVo.dataStatus == 2" @click="audit(currentDetailInfo.projectLampparamVo.id)"><i class="el-icon-folder-checked"></i>提交审核</li>  
                                <!-- <li @click="deleteLampParam(currentDetailInfo.projectLampparamVo.id)"><img src="@/assets/images/bb4.jpg" alt="">删除</li>   -->
                                <li v-show="currentDetailInfo.projectLampparamVo.makingWay == 1" @click="downloadDetaildWorld()"><img src="@/assets/images/bb5.jpg" alt="">导出word</li> 
                                 
                                <li @click="downloadDetaildPdf()"><img src="@/assets/images/bb6.jpg" alt="">导出pdf</li>  
                                </template>
                                <li @click="prev()"><img src="@/assets/images/bb7.jpg" alt="">上一条</li>  
                                <li @click="next()"><img src="@/assets/images/bb8.jpg" alt="">下一条</li>   
                            </ul>
                        </div>
                        <div class="lsdeList" v-else-if='isgdorPending!=6'> <!-- 项目库-->
                            <ul>
                                <li @click="copyLamparamProject(currentDetailInfo.projectLampparamVo.id)"><img src="@/assets/images/bb1.jpg" alt="">添加至我的项目</li>  
                            </ul>
                        </div>
                    </div>    
                </div>
            </div>
            </el-form>
        </el-dialog>
</template>
<script>
import { Loading } from 'element-ui';
export default {
    data(){
        return{
            userhaveRole:false,
            isgdorPending:'',
            showDetail:false,
            currentDetailInfo : {
                projectLampparamVo:{
                },
                projectParamindexList:[{
                    brightnessAvgMin:''
                }]
            },
            embedHhtml:'',
            pdfSrc:'',
            showDetailFlag:true,
            detailSkip:1,
            targetProjectId:'',
            loadingInstance: false,
            rerecommend:false,//点击推荐灯参的话  为真  默认为false
        }
    },
    methods:{
        copyLamparamProject(id){
            let self = this
            this.$http.postQuery('/api/lampparams/copyLamparam/2',{lampparamIds:id,targetProjectId:this.targetProjectId},function(res){
                self.$message({
                    message: "导入成功！",
                    type: "success"
                });
                self.$emit("refreshdetail")
            })
        },
        prev(){
            this.$emit("perv")
        },
        next(){
            this.$emit("next")
        },
        downloadDetaildPdf(){
            
            let self = this
            this.$http.get('/api/lampparams/generateTyLampparamPdf/'+this.currentDetailInfo.projectLampparamVo.id,{},function(res){
                self.downloadFile(self.ImgPath + "/" + res.data.fileName)
                
            })
        },
        downloadFile(url){
            window.open(url)
        },
        downloadDetaildWorld(){
            let self = this
            this.$http.get('/api/lampparams/downloadTyLampparamWord/'+this.currentDetailInfo.projectLampparamVo.id,{},function(res){
                self.downloadFile(self.ImgPath + "/" +res.data.fileName)
            })
        },
        audit(id){
            this.$emit("audit",id)
        },
        gotoUpdatePdf(id){
            this.$emit("gotoUpdatePdf",id)
        },
        showPDFEditView(id){
            this.$emit("showPDFEditView",id)
        },
        showAddToMyProject(type){
            this.$emit("showAddToMyProject",type)
        },
        show(id,flag,isgdorPending,userhaveRole,targetProjectId,rerecommend){
            console.log(id)
            this.isgdorPending = isgdorPending
            this.userhaveRole = userhaveRole;
            this.rerecommend = rerecommend;
            let self = this
            self.currentDetailInfo = {
                projectLampparamVo:{},
                projectParamindexList:[{
                    brightnessAvgMin:''
                }]
            }

            //不显示时将所有按钮隐藏
            if(flag == false){
                self.showDetailFlag = flag
                self.isgdorPending = 6;
            }else{
                self.showDetailFlag = true
            }

            self.showDetail = true
            self.targetProjectId = targetProjectId
        /*    this.$http.get("/api/lampparams/generateTyLampparamPdf/"+id,{},(res)=>{
                var fileName =res.data.fileName;
                let pdfSrc = this.$http.getSignUrl('/api/previewPdf',{fileName:fileName,token:this.$store.state.token});
                this.embedHhtml = `<embed src="${pdfSrc}" width="100%" height="725px">`
            })
*/

            self.$http.get('/api/lampparams/view/'+id,{},function(res){
               if(res.success){
                   self.currentDetailInfo = res.data
                   //通用模板
                   if( res.data.projectLampparamVo.rootIn==4){
                       var pdfPath =res.data.projectLampparamVo.pdfPath;
                       let pdfSrc = self.$http.getSignUrl('/api/previewPdf',{fileName:pdfPath,token:self.$store.state.token});
                       console.log(pdfSrc)
                       self.embedHhtml = `<embed src="${pdfSrc}" width="100%" height="725px">`
                   }else{
                       if(self.currentDetailInfo.projectLampparamVo.contestTypeString == '窗框' || self.currentDetailInfo.projectLampparamVo.contestTypeString == '复合面'){
                           self.detailSkip = 2
                       }else{
                           self.detailSkip = 1
                       }
                   }
                       self.$emit("setDetailInfo",res.data)

               }

            })
          /* this.$http.get('/api/lampparams/view/'+id,{},function(res){
                if(res.success){
                    self.currentDetailInfo = res.data
                    if(self.currentDetailInfo.projectLampparamVo.contestTypeString == '窗框' || self.currentDetailInfo.projectLampparamVo.contestTypeString == '复合面'){
                        self.detailSkip = 2
                    }else{
                        self.detailSkip = 1
                    }
                    self.$emit("setDetailInfo",res.data)
                }
            })*/
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" >
#typeshowhtml{
    background: rgba(0,0,0,.4);
    z-index: 99;
    .toppom{
        ul{
            max-height: 70vh;
         overflow: auto
        }
    }
    .el-dialog{
        width: 86%;
         margin-top: 5vh !important;
         
    }
    .el-dialog__body{
            padding-top: 0;
        }
    .contrascont{
        min-height: 120px;
        min-width: 260px;
        display: inline-block;
        vertical-align: middle;  
        font-size: 18px;
        text-align: left;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        padding: 0px !important;
        width: 100%;
        .hst{
            font-size:22px;
            font-weight: bold;
            color: #000;
            margin-bottom: 10px;
            text-align: center;
        }
        .lsde{
            img{
                max-height: 100%;
            }
            li{
                float: left;
                text-align: center;
                border: solid 1px rgba(184, 205, 217, 0.4);
                padding: 10px 12px;
                font-size: 14px;
                margin: 0;
            }
           .title{
               height: 48px;
                background-color: #5a63a3;
                text-align: center;
                line-height: 48px;
                color: #fff;
                font-size: 18px;
                width: 100%;
                padding: 0;
           }
           .cd1{
               background-color: #f6f7fb;
               text-align: center;
               height: 200px;
               width: 9%;
           }
           .cd2{
               width: 41%;
               height: 200px;
           }
           .cd3{
               width: 9%;
                background-color: #f6f7fb;
                height: 50px;
           }
           .cd4{
               width: 16%;
               height: 50px;
               text-align: left;
               padding: 0 12px;
           }
           .cd5{
               width: 50%;
               height: 50px;
               text-align: left;
                padding: 0 12px;
           }
           .cd6{
               width: 91%;
               padding: 15px 2%;
           }
           .cd7{
               height: 45px;
                background-color: #f6f7fb;
                width: 9%;
           }
           .cd8{
               height: 45px;
               width: 91%;
               text-align: left;
               padding: 0 15px;
           }
           .cd9{
               height: 45px;
               width: 41%;
               text-align: left;
               padding: 0 15px;
               .BoxTable{
                   height: 45px;
                   .BoxCell{
                       height: 45px;
                       div{
                           display: inline-block;
                           width: auto;
                       }
                   }
               }
           }
        }
        .lsdeList{
            text-align: right;
            margin-top: 20px;
            li{
                display: inline-block;
                margin-left: 16px;
                float: none;
                border: none;
                color: #666666;
                font-size: 14px;
                cursor: pointer;
                img{
                    display: inline-block;
                    position: relative;
                    top: 3px;
                    margin-right: 3px;
                }
            }
        }
        .close{
            position: absolute;
            right: 10px;
            top: 10px;
            background-color: #5a63a3;
            width: 28px;
            height: 28px;
            display: inline-block;
            color: #fff;
            border-radius: 50%;
            line-height: 28px;
            text-align: center
        }
    }
}
</style>